<template>
	<div class="data-table-container customize-table">
		<v3-table :headers="headers" :items="itemsToDisplay" alternating :rows-per-page="rowsPerPage" hide-rows-per-page
			hide-footer>
			<template #header-agentDetial="header">
				<div class="text-left cursor-pointer">
					{{ $t('agent_detail') }}
				</div>
			</template>
			<template #header-skills="header">
				<div class="text-left cursor-pointer">
					{{ $t('skill_and_certificates') }}
				</div>
			</template>
			<template #item-icon="{ id, active }">
				<div class="d-flex">
					<v-icon style="
							color: grey;
							padding-right: 10px;
							cursor: pointer;
						" @click="editAgent(id)">mdi-pencil</v-icon>
					<v-chip density="default" variant="outlined" class="align-center"
						@click="activeOrInactiveAgent(id, active)">
						{{ active ? 'Inactive' : 'Active' }}
					</v-chip>
				</div>
			</template>
			<template #item-assignButton="{ id }">
				<div class="my-auto font-weight-bold cursor-pointer" @click="assignIncidentToAgent(id)">
					{{ $t('assign') }}
					<span>
						<v-icon size="x-large">
							mdi-arrow-right-bold-circle-outline
						</v-icon>
					</span>
				</div>
			</template>
			<template #item-active="{ active }">
				<v-chip :class="active ? 'active-status' : 'inactive-status'" density="default"><v-icon start
						icon="mdi-circle" :class="active
							? 'active-status-icon'
							: 'inactive-status-icon'
							"></v-icon>{{ active ? 'Active' : 'Inactive' }}
				</v-chip>
			</template>
			<template #item-agentDetial="{
				lineName,
				firstName,
				lastName,
				phone,
				id,
				pictureUrl,
			}">
				<div class="d-flex">
					<div>
						<v-img :width="80" aspect-ratio="1/1" src="@/assets/User.png"></v-img>
					</div>
					<div class="my-auto">
						<p style="font-weight: bold">
							{{ $t('line_name') }}: {{ lineName }}
						</p>
						<p>{{ firstName }} {{ lastName }}</p>
						<p style="font-size: 0.9rem; color: grey">
							{{ phone }}
						</p>
					</div>
				</div>
			</template>

			<!-- <template #item-specialization="{ specialization }">
				<p>{{ specialization }}</p>
			</template> -->

			<template #item-skills="{ skills, agentCertificate }">
				<v-chip v-for="skill in skills" class="ma-1" size="small" :key="skill.id" :style="{
					'background-color': colorGenerator(skill.name),
				}">
					<span style="color: #fff; font-weight: 500">
						{{ skill.name }}
					</span>
				</v-chip>

				<v-chip v-for="cert in agentCertificate" class="ma-1" size="small" :key="cert.id" :style="{
					'background-color': colorGenerator(
						cert.certificateName
					),
				}">
					<span style="color: #fff; font-weight: 500">
						{{ cert.certificateName }}
					</span>
				</v-chip>
			</template>
		</v3-table>

		<div class="d-flex flex-row-reverse mx-10">
			<div class="d-flex">
				<div class="my-auto">{{ $t('rows_per_page') }}:</div>
				<v-select variant="underlined" :items="[10, 25, 50, 100]" style="max-width: 4.5rem" class="ml-8 my-auto"
					v-model="totalRowsPerPage" @update:model-value="onClick(totalRowsPerPage)"></v-select>
				<div class="my-auto ml-10">
					{{
						this.initialPage == 1
							? this.initialPage
							: (this.initialPage - 1) * this.totalRowsPerPage + 1
					}}
					- {{ this.initialPage * this.totalRowsPerPage }} of
					{{ this.totalIncidents }}
				</div>
				<div class="my-auto">
					<v-btn :disabled="initialPage == 1" variant="text" @click="previousPage">
						<v-icon size="30">mdi-chevron-left</v-icon>
					</v-btn>
					<v-btn :disabled="initialPage * rowsPerPage >= items.length" variant="text" @click="nextPage">
						<v-icon size="30">mdi-chevron-right</v-icon>
					</v-btn>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue3EasyDataTable from 'vue3-easy-data-table'
import 'vue3-easy-data-table/dist/style.css'
import settings from '@/services/API/settings';

export default {
	async created() {
		await settings.getDefaultPageValue().then((response) => {
			this.totalRowsPerPage = response.data.pageSize
		})
	},
	name: 'DataTable',
	components: {
		'v3-table': Vue3EasyDataTable,
	},
	props: {
		headers: Array,
		items: Array,
		rowsPerPage: {
			type: Number,
			default: 100,
		},
	},
	emits: [
		'showAgent',
		'openAgentEditor',
		'openActiveInactiveDialog',
		'assignAgent',
	],
	methods: {
		assignIncidentToAgent(id) {
			this.$emit('assignAgent', id)
		},
		goToAgentInformationPage(id) {
			this.$router.push(
				`/agent-list/verified-agent/agent-information?agentId=${id}`
			)
		},
		editAgent(id) {
			this.$emit('openAgentEditor', id)
		},
		activeOrInactiveAgent(id, active) {
			this.$emit('openActiveInactiveDialog', id, active)
		},
		convertStringToAscii(str) {
			return str
				.split('')
				.map((char) => char.charCodeAt(0))
				.join('')
		},
		colorGenerator(seed) {
			const hex = Math.floor(
				Math.abs(
					Math.sin(this.convertStringToAscii(seed.toLowerCase())) *
					16777215
				)
			).toString(16)

			return `#${hex}`
		},
		previousPage() {
			this.initialPage -= 1

			this.$emit('pageNumber', this.initialPage)
		},
		nextPage() {
			this.initialPage += 1

			this.$emit('pageNumber', this.initialPage)
		},
		onClick(length) {
			this.$emit('totalRowsPerPage', length)
		},
		updateCurrentPage(page) {
			this.currentPage = page
		},

	},
	data: () => ({
		openCreateDialog: false,
		currentPage: 1,
		colorCode: {
			low: 'gray',
			normal: 'green',
			high: 'yellow',
			urgent: 'red',
		},
		agentDetials: {},
		itemSelected: [],
		totalRowsPerPage: '10',
		initialPage: 1,
		initialRowsPerPage: '10',
		totalIncidents: '100',
	}),
	computed: {
		itemsToDisplay() {
			// Reverse the array to display the latest items at the top
			const reversedItems = [...this.items].reverse()

			const startIndex = (this.initialPage - 1) * this.rowsPerPage
			const endIndex = startIndex + this.rowsPerPage

			// Slice the reversed array
			return reversedItems.slice(startIndex, endIndex)
		},
	},
}
</script>
<style scoped>
.customize-table {
	--easy-table-border: 1px solid var(--primary-color-lighten);
	--easy-table-row-border: 1px solid var(--primary-color-lighten);
	--easy-table-header-font-size: 18px;
	--easy-table-header-height: 50px;
	--easy-table-header-background-color: var(--secondary-color);
	--easy-table-header-item-padding: 15px 20px;
	/* --easy-table-header-font-color: white; */

	--easy-table-body-row-background-color: var(--secondary-color-lighten);
	--easy-table-body-row-height: 50px;
	--easy-table-body-row-font-size: 16px;
	--easy-table-body-row-hover-background-color: var(--primary-color-lighten);

	--easy-table-body-item-padding: 10px 15px;
	--easy-table-footer-background-color: var(--gray-1);
	--easy-table-footer-font-size: 14px;
	--easy-table-footer-padding: 0px 10px;
	--easy-table-footer-height: 50px;

	--easy-table-loading-mask-background-color: #000000;
	font-family: 'Roboto';
}

.active-status {
	background-color: #d3f9dc;
	color: green;
	padding: 10px;
	width: 100px;
	/* margin-align: auto; */
	display: flex;
	justify-content: center;
	font-weight: bold;

	/* border-radius: 10px; */
}

.active-status-icon {
	color: green;
}

.inactive-status-icon {
	color: rgb(172, 44, 44);
}

.inactive-status {
	background-color: #f09d70;
	color: rgb(172, 44, 44);
	padding: 10px;
	width: 100px;
	text-align: center;
	display: flex;
	justify-content: center;
	font-weight: bold;
	/* border-radius: 10px; */
}

.link {
	font-weight: 500;
	cursor: pointer;
}
</style>
